import { MARQUEE_ITEMS } from "../data/content";

const Diamond = () => (
    <svg width="6" height="6" viewBox="0 0 8 8" className="shrink-0 mx-7" aria-hidden="true">
        <rect x="1.5" y="1.5" width="5" height="5" transform="rotate(45 4 4)" fill="#A38020" fillOpacity="0.5" />
    </svg>
);

export const Marquee = () => {
    const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div
            className="bg-ivory border-y border-navy-900/10 py-3.5 overflow-hidden"
            data-testid="editorial-marquee"
            aria-hidden="true"
        >
            <div className="flex w-max animate-marquee">
                {items.map((item, i) => (
                    <span key={i} className="flex items-center font-mono text-[11px] text-navy-900/55 tracking-[0.25em] uppercase whitespace-nowrap">
                        {item}
                        <Diamond />
                    </span>
                ))}
            </div>
        </div>
    );
};
